import { Banner } from '@stenajs-webui/elements';
import { useHasAnyValidCustomer } from '../graphql/useHasAnyValidCustomer';
import { Information } from '../texts';

interface NoValidCustomersBannerProps {
  intermodal?: boolean;
}

export function NoValidCustomersBanner({ intermodal = false }: NoValidCustomersBannerProps) {
  const hasAnyValidCustomer = useHasAnyValidCustomer({ includeIntermodalCustomers: intermodal });

  if (hasAnyValidCustomer) {
    return null;
  }

  return <Banner variant={'warning'} text={Information.NoValidCustomers} />;
}
